<template>
  <div>
    <div class="exhi_list container row">
      <div class="schedule_item row col-xl-6 col-lg-3 col-md-4 col-6" v-for="(exhi, index) in dataRegioned.slice((for_show.page-1)*for_show.per_page, for_show.page*for_show.per_page)" :key="exhi.id">
        <div class="col-xl-4 col-12" style="padding:0;">
          <div class="schedule_image_box"><a :href="schedule_extro.slice((for_show.page-1)*for_show.per_page, for_show.page*for_show.per_page)[index]" target="_blank"><img :src="exhi.image2_url" :alt="exhi.id"></a></div>
        </div>
        <div class="schedule_info col-xl-8 col-12">
          <h3><a :href="schedule_extro.slice((for_show.page-1)*for_show.per_page, for_show.page*for_show.per_page)[index]" target="_blank" v-html="exhi.short"></a></h3>
          <p><i class="fa fa-calendar"></i><span v-html="' ' + exhi.start_date +'~'+ exhi.end_date.slice(5,10)"></span></p>
          <p><i class="fa fa-map-marker" style="width: 14.86px;text-align:center;"></i> {{exhi.address.name}}</p>
          <p><a :href="schedule_extro.slice((for_show.page-1)*for_show.per_page, for_show.page*for_show.per_page)[index]" target="_blank">前往官網 ⇀</a></p>
        </div>
      </div>
      <div v-show="dataRegioned.length == 0 && for_show.no_data == false" style="margin: auto;font-size:21px;">
        <img src="../../assets/loading.gif">
      </div>
      <div v-show="for_show.no_data" style="margin:auto;font-size:21px;">很抱歉，查無相關展覽資訊</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["for_show", "dataRegioned", "schedule_extro"],
}
</script>

<style>
.exhi_list { 
  min-height: 200px; 
  margin: 50px auto;
  min-height: 200px;
}
.exhi_list a {
  color: #00a0e9;
  text-decoration: none;
  font-weight: bold;
}
.exhi_list .schedule_item {
  padding: 20px 0;
  margin: 0;
}
.exhi_list .schedule_item:nth-child(odd) { border-right: 1px solid #00a0e9; }
.exhi_list .schedule_item .schedule_image_box {
  width: 80%;
  margin: auto;
}
.exhi_list .schedule_item .schedule_image_box img {
  display: block;
  width: 100%;
  max-width: 100%;
  margin: auto;
}
.exhi_list .schedule_item .schedule_info { padding: 0; }
.exhi_list .schedule_item .schedule_info h3 {
  margin: 0;
  width: 85%;
  font-size: 17px;
  min-height: 40px;
}
.exhi_list .schedule_item .schedule_info h3 a{ color: black; }
.exhi_list .schedule_item .schedule_info p {
  font-size: 15px;
  margin: 15px 0;
}
@media (max-width: 1600px) {
  .exhi_list .schedule_item {
    padding-bottom: 10px;
    margin-bottom: 30px;
  }
  .exhi_list .schedule_item:nth-child(odd) {border-right: 0;}
  .exhi_list .schedule_item .schedule_info h3 {
    width: 80%;
    margin: 10px auto;
  }
  .exhi_list .schedule_item .schedule_info p {
    width: 80%;
    margin: 15px auto;
  }
}

@media (max-width: 1600px) {
  .exhi_list .schedule_item .schedule_info h3 { font-size: 15px; }
  .exhi_list .schedule_item .schedule_info p { font-size: 13px; }
}











</style>